export interface OnboardingState {
  cols: string[];
  rows: any[][];
  maps: Record<string, string>;
  step: number;
  fileName: string;
}

export function createInitialState(): OnboardingState {
  return { cols: [], rows: [], maps: {}, step: 1, fileName: '' };
}
